import { Routes } from "@angular/router";
import { authGuard, guestGuard, permissionGuard } from "./core/guards/auth.guard";

export const routes: Routes = [
  {
    path: "login",
    canActivate: [guestGuard],
    loadComponent: () =>
      import("./features/auth/login.component").then(m => m.LoginComponent),
  },
  {
    path: "",
    canActivate: [authGuard],
    loadComponent: () =>
      import("./layout/shell.component").then(m => m.ShellComponent),
    children: [
      { path: "", redirectTo: "dashboard", pathMatch: "full" },
      {
        path: "dashboard",
        loadComponent: () => import("./features/dashboard/dashboard.component").then(m => m.DashboardComponent),
      },
      {
        path: "cuisine",
        canActivate: [permissionGuard("kitchen.screen")],
        data: { mode: "kitchen" },
        loadComponent: () => import("./features/orders/orders.component").then(m => m.OrdersComponent),
      },
      {
        path: "cuisine/consommation",
        canActivate: [permissionGuard("stock.consume")],
        loadComponent: () =>
          import("./features/orders/kitchen-consumption.component").then(m => m.KitchenConsumptionComponent),
      },
      {
        path: "bar",
        canActivate: [permissionGuard("orders.view")],
        data: { mode: "bar" },
        loadComponent: () => import("./features/orders/orders.component").then(m => m.OrdersComponent),
      },
      {
        path: "commandes",
        canActivate: [permissionGuard("orders.view")],
        loadComponent: () => import("./features/orders/history/order-history.component").then(m => m.OrderHistoryComponent),
      },
      {
        path: "commandes/manual",
        canActivate: [permissionGuard("orders.manage")],
        loadComponent: () =>
          import("./features/orders/manual/manual-order.component").then(m => m.ManualOrderComponent),
      },
      { path: "orders", redirectTo: "cuisine", pathMatch: "full" },
      { path: "orders/history", redirectTo: "commandes", pathMatch: "full" },
      { path: "orders/manual", redirectTo: "commandes/manual", pathMatch: "full" },
      {
        path: "caisse/recap",
        canActivate: [permissionGuard("payments.manage")],
        loadComponent: () =>
          import("./features/caisse/caisse-recap.component").then(m => m.CaisseRecapComponent),
      },
      {
        path: "caisse",
        canActivate: [permissionGuard("payments.manage")],
        loadComponent: () => import("./features/caisse/caisse.component").then(m => m.CaisseComponent),
      },
      {
        path: "reporting",
        canActivate: [permissionGuard("reports.view")],
        loadComponent: () => import("./features/reporting/reporting.component").then(m => m.ReportingComponent),
      },
      {
        path: "rapport-ia",
        canActivate: [permissionGuard("reports.view")],
        loadComponent: () => import("./features/reporting/rapport-ia.component").then(m => m.RapportIaComponent),
      },
      {
        path: "menu/categories",
        canActivate: [permissionGuard("menu.manage")],
        loadComponent: () => import("./features/menu-categories/menu-categories.component").then(m => m.MenuCategoriesComponent),
      },
      {
        path: "menu",
        canActivate: [permissionGuard("menu.manage")],
        loadComponent: () => import("./features/menu/menu.component").then(m => m.MenuComponent),
      },
      {
        path: "stories",
        canActivate: [permissionGuard("menu.manage")],
        loadComponent: () => import("./features/stories/stories.component").then(m => m.StoriesComponent),
      },
      {
        path: "tables",
        canActivate: [permissionGuard("tables.manage", ["tables.status"])],
        loadComponent: () => import("./features/tables/tables.component").then(m => m.TablesComponent),
      },
      {
        path: "staff",
        canActivate: [permissionGuard("staff.manage")],
        loadComponent: () => import("./features/staff/staff.component").then(m => m.StaffComponent),
      },
      {
        path: "theme",
        canActivate: [permissionGuard("theme.manage")],
        loadComponent: () => import("./features/theme-editor/theme-editor.component").then(m => m.ThemeEditorComponent),
      },
      {
        path: "stock",
        canActivate: [permissionGuard("stock.manage")],
        loadComponent: () => import("./features/stock/stock.component").then(m => m.StockComponent),
      },
      {
        path: "settings",
        canActivate: [permissionGuard("settings.manage")],
        loadComponent: () => import("./features/settings/settings.component").then(m => m.SettingsComponent),
      },
      {
        path: "abonnement",
        loadComponent: () => import("./features/abonnement/abonnement.component").then(m => m.AbonnementComponent),
      },
    ],
  },
  { path: "**", redirectTo: "" },
];
